module.exports = __webpack_public_path__ + "static/media/add.0217ef20.svg";